// Cash drawer (fond de caisse) shift management types.
// Mirrors backend/src/cash-drawer/entities and dto field-for-field.

export enum CashDrawerShiftStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum CashMovementType {
  CASH_IN = 'CASH_IN',
  CASH_OUT = 'CASH_OUT',
}

export enum CashMovementReason {
  CHANGE_FUND = 'CHANGE_FUND',
  PETTY_EXPENSE = 'PETTY_EXPENSE',
  BANK_DEPOSIT = 'BANK_DEPOSIT',
  CORRECTION = 'CORRECTION',
  OTHER = 'OTHER',
}

export interface CashDrawerShift {
  id: string;
  organizationId: string;
  locationId: string;
  location?: { id: string; name: string };
  openedByUserId: string;
  openedByUser?: { id: string; firstName?: string; lastName?: string; email?: string };
  closedByUserId?: string | null;
  closedByUser?: { id: string; firstName?: string; lastName?: string; email?: string } | null;
  openingBalance: number;
  expectedClosingBalance: number | null;
  countedClosingBalance: number | null;
  discrepancy: number | null;
  status: CashDrawerShiftStatus;
  openedAt: string;
  closedAt: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CashMovement {
  id: string;
  shiftId: string;
  organizationId: string;
  type: CashMovementType;
  amount: number;
  reason: CashMovementReason;
  note?: string | null;
  recordedByUserId: string;
  createdAt: string;
}

export interface CashDrawerShiftSummary extends CashDrawerShift {
  movements: CashMovement[];
}

export interface OpenShiftPayload {
  locationId: string;
  openingBalance: number;
}

export interface CloseShiftPayload {
  countedClosingBalance: number;
  notes?: string;
}

export interface CreateCashMovementPayload {
  type: CashMovementType;
  amount: number;
  reason: CashMovementReason;
  note?: string;
}

export interface QueryShiftsParams {
  page?: number;
  limit?: number;
  locationId?: string;
  status?: CashDrawerShiftStatus;
}

// Matches backend's PagePaginationResult<T> envelope (createPaginatedResponse), not the flat
// {data,total} shape some other list endpoints (e.g. suppliers) use.
export interface PaginatedShiftsResponse {
  data: CashDrawerShift[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}
